import $ from 'jquery';
import 'what-input';
import './libraries/hoverintent.min.js';
import './components/oembed.js';

import initAnchorLinks from './libraries/anchor-links';
import initLinkContainer from './libraries/link-container';
import initImpactStats from '../blocks_g/impact-stats/js/impact-stats.js';
import initAccordion from './modules/init-accordion.js';
import initTabModules from './modules/init-tab-modules.js';
import initQuoteSliderSplide from '../blocks_g/quote-slider/js/init-splide';
import initStandardCarouselSplide from '../blocks_g/standard-carousel/js/init-splide';
import initUsaJobsFinder from '../blocks/usa-jobs-finder/js/usa-jobs-finder.js';
import initFilteredList from '../blocks_g/filtered-list/js/filtered-list.js';
import initSiteHeader from './modules/init-site-header.js';
import initStickyNav from './modules/init-sticky-nav.js';
import initFitButtons from './modules/init-fit-buttons.js';
import initFooterSignup from './modules/init-footer-signup.js';
import initNewTabHints from './modules/init-new-tab-hints.js';
import initScrollRegions from './modules/init-scroll-regions.js';
import initAnimations from './modules/animations.js';

window.$ = window.jQuery = $;

$(() => {
	document.documentElement.style.visibility = 'visible';
	$('body').addClass('document-ready');

	initAnchorLinks();
	initLinkContainer();
	initAccordion();
	initImpactStats();
	initTabModules();
	initQuoteSliderSplide();
	initStandardCarouselSplide();
	initUsaJobsFinder();
	initFilteredList();
	initSiteHeader();
	initStickyNav();
	initFitButtons();
	initFooterSignup();
	initNewTabHints();
	initScrollRegions();
	initAnimations();
});
